import { create } from 'zustand';

const usePlants = create((set) => ({
    plants: [],
    plantOrder: [],
    scintillaPlants: [],
    powerMeasuresData: [],
    powerMeasuresLoading: false,
    setPlants: (plants) => set((state) => ({ ...state, plants })),
    setPlantOrder: (plantOrder) => set((state) => ({ ...state, plantOrder })),
    setScintillaPlants: (scintillaPlants) => set((state) => ({ ...state, scintillaPlants })),
    setPowerMeasuresData: (powerMeasuresData) => set((state) => ({ ...state, powerMeasuresData })),
    setPowerMeasuresLoading: (powerMeasuresLoading) => set((state) => ({ ...state, powerMeasuresLoading })),
}));

export default usePlants;
